import { render } from "./timerShaft.vue?vue&type=template&id=dc33a026&scoped=true"
import script from "./timerShaft.vue?vue&type=script&lang=js"
export * from "./timerShaft.vue?vue&type=script&lang=js"

import "./timerShaft.vue?vue&type=style&index=0&id=dc33a026&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-dc33a026"

export default script